import { HStack, Stack, Text } from '@adc/parallax-component-library';

import { buildTestId } from '~/utilities/buildTestId';

type ListItemProps = {
  children?: React.ReactElement[];
  fontToken?: React.ComponentProps<typeof Text>['type'];
  testID?: string;
};

export const ListItem = ({ children, fontToken, testID }: ListItemProps) => {
  if (!children?.length) {
    return null;
  }

  const textChildren = children.filter(
    (child) => typeof child === 'string' || child.type === Text,
  );

  const restChildren = children.filter(
    (child) => typeof child !== 'string' && child.type !== Text,
  );

  return (
    <Stack tag="li" style={{ display: 'list-item' }} testID={testID}>
      <HStack>
        <Text
          type={fontToken}
          flexShrink={1}
          testID={buildTestId({ testID, suffix: 'text' })}
        >
          {textChildren}
        </Text>
      </HStack>
      <Stack marginLeft="$2">{restChildren}</Stack>
    </Stack>
  );
};

ListItem.displayName = 'ListItem';

type ListProps = {
  children?: React.ReactElement;
  listType?: 'ol' | 'ul';
  testID?: string;
};

export const List = ({ children, listType = 'ul', testID }: ListProps) => (
  <Stack
    tag={listType}
    paddingInlineStart="$6"
    marginInlineStart={0}
    marginInlineEnd={0}
    marginBlockStart="$2"
    marginBlockEnd="$2"
    justifyContent="center"
    style={{ listStyleType: listType === 'ol' ? 'decimal' : 'disc' }}
    testID={testID}
  >
    {children}
  </Stack>
);
